<template>
  <app-content class="h-panel">
    <div class="h-panel-bar"><span class="h-panel-title">银行回单列表</span></div>
    <div class="margin-right-left margin-top">
      <account-date-choose v-model="accountDate"/>
      <div class="float-right">
        <Button color="primary" icon="h-icon-plus" @click="addBankReceipts">新增银行回单</Button>
        <Button :loading="loading" @click="exportData">导出</Button>
        <Button v-if="User.role!=='View'" color="yellow" :loading="repairLoading" @click="batchRepair">批量修复</Button>
        <Button v-if="User.role!=='View'" color="red" @click="batchDelete">删除</Button>
      </div>
    </div>
    <div class="h-panel-body">
      <div class="modern-table">
        <div class="table-header">
          <div class="header-cell checkbox-cell">
            <input :checked="checkAll" type="checkbox" @click="checkAll=!checkAll">
          </div>
          <div class="header-cell receipt-no-cell">单据编号</div>
          <div class="header-cell date-cell">转账日期</div>
          <div class="header-cell type-cell">类型</div>
          <div class="header-cell amount-cell">金额</div>
          <div class="header-cell party-cell">收款人/付款人</div>
          <div class="header-cell summary-cell">摘要</div>
          <div class="header-cell actions-cell">操作</div>
        </div>
      </div>
      <div v-if="!datas.length" class="empty-state">
        <div class="empty-icon">🏦</div>
        <div class="empty-text">暂无银行回单数据</div>
        <div class="empty-hint">点击右上角"新增"按钮添加第一张银行回单</div>
      </div>
      <div v-for="data in datas" :key="data.id" class="table-row">
        <div class="row-cell checkbox-cell">
          <input :class="{'display':data._checked}" v-model="data._checked" type="checkbox">
        </div>
        <div class="row-cell receipt-no-cell">
          <div class="cell-content">
            <div class="primary-text">{{ data.receiptsNo }}</div>
            <div class="secondary-text" v-if="data.serialNumber">流水号: {{ data.serialNumber }}</div>
          </div>
        </div>
        <div class="row-cell date-cell">
          <div class="cell-content">
            <div class="primary-text">{{ data.transferDate || data.receiptsDate | date }}</div>
            <div class="secondary-text" v-if="data.receiptsDate && data.transferDate && data.receiptsDate !== data.transferDate">
              单据: {{ data.receiptsDate | date }}
            </div>
          </div>
        </div>
        <div class="row-cell type-cell">
          <div class="cell-content">
            <div class="type-badge" :class="getTypeBadgeClass(data.type)">
              {{ data.type }}
            </div>
          </div>
        </div>
        <div class="row-cell amount-cell">
          <div class="cell-content">
            <div class="amount-text">{{ data.amount | numFormat }}</div>
            <div class="secondary-text" v-if="data.amountInWords">{{ data.amountInWords }}</div>
          </div>
        </div>
        <div class="row-cell party-cell">
          <div class="cell-content">
            <div class="primary-text" :title="getCounterpartyDisplay(data)">
              {{ getCounterpartyDisplay(data) || '-' }}
            </div>
            <div class="secondary-text" v-if="getCounterpartyAccount(data)">
              {{ getCounterpartyAccount(data) }}
            </div>
          </div>
        </div>
        <div class="row-cell summary-cell">
          <div class="cell-content">
            <div class="primary-text" :title="data.summary">{{ data.summary || '-' }}</div>
            <div class="secondary-text" v-if="data.transactionInstitution">
              {{ data.transactionInstitution }}
            </div>
          </div>
        </div>
        <div class="row-cell actions-cell">
          <div class="action-buttons">
            <router-link class="action-btn view-btn" :to="{name:'BankReceiptsForm',params:{bankReceiptsId:data.id}}">
              <i class="icon-view">👁</i>查看
            </router-link>
            <router-link v-if="User.role!=='View'" class="action-btn edit-btn" :to="{name:'BankReceiptsForm',params:{bankReceiptsId:data.id}}">
              <i class="icon-edit">✏️</i>修改
            </router-link>
            <button v-if="User.role!=='View' && needsRepair(data)" class="action-btn repair-btn" @click="repairSingle(data)">
              <i class="icon-repair">🔧</i>修复
            </button>
            <button v-if="User.role!=='View'" class="action-btn delete-btn" @click="remove(data)">
              <i>🗑</i>删除
            </button>
          </div>
        </div>
      </div>
      <Pagination
        v-model="pagination"
        @change="currentChange"
        @size-change="handleSizeChange"
        layout="sizes, pager"
        :page-sizes="[10, 20, 50]"
        small
        align="center"/>
    </div>


  </app-content>
</template>

<script>
  import moment from 'moment'
  import {mapState} from 'vuex'

  export default {
    name: "BankReceiptsList",
    components: {
    },
    data() {
      return {
        datas: [],
        accountDate: null,
        pagination: {
          page: 1,
          size: 10,
          total: 0
        },
        loading: false,
        repairLoading: false,
        checkAll: false
      };
    },
    watch: {
      checkAll(nval) {
        let data = Array.from(this.datas);
        data.forEach(val => val._checked = nval);
        this.datas = data;
      },
      accountDate() {
        this.pagination.page = 1;
        this.loadList();
      }
    },
    computed: {
      ...mapState(['User', 'currentAccountSets']),
      date() {
        return moment(this.accountDate);
      }
    },
    methods: {
      currentChange() {
        this.loadList();
      },
      handleSizeChange(size) {
        this.pagination.size = size;
        this.pagination.page = 1;
        this.loadList();
      },
      addBankReceipts() {
        this.$router.push({name: 'BankReceiptsForm'});
      },
      exportData() {
        // 导出功能实现
        this.$Message("导出功能开发中");
      },
      loadList() {
        this.loading = true;
        this.$api.bankReceipts.list({
          receipts_year: this.date.year(),
          receipts_month: this.date.month() + 1,
          page: this.pagination.page,
          size: this.pagination.size
        }).then(({data}) => {
          this.datas = data.records;
          this.pagination = {
            page: data.current,
            size: data.size,
            total: data.total
          }
        }).finally(() => {
          this.loading = false;
        });
      },
      remove(data) {
        this.$Confirm("确认删除?").then(() => {
          this.loading = true;
          this.$api.bankReceipts.delete(data.id).then(() => {
            this.loadList();
            this.$Message("删除成功");
          }).finally(() => {
            this.loading = false;
          });
        });
      },
      batchDelete() {
        let checked = this.datas.filter(value => value._checked);
        if (checked.length === 0) {
          this.$Message("请选择要删除的银行回单");
          return;
        }
        this.$Confirm(`确认删除选中的 ${checked.length} 条银行回单?`).then(() => {
          this.loading = true;
          let ids = checked.map(value => value.id);
          this.$api.bankReceipts.batchDelete(ids).then(() => {
            this.loadList();
            this.$Message("批量删除成功");
          }).finally(() => {
            this.loading = false;
          });
        });
      },
      getCounterpartyDisplay(data) {
        // 根据类型显示收款人或付款人信息
        if (data.type === '收入') {
          // 收入类型显示付款人信息
          return data.payerName || data.payerAccount || '未知付款人';
        } else {
          // 支出类型显示收款人信息
          return data.payeeName || data.payeeAccount || '未知收款人';
        }
      },

      getCounterpartyAccount(data) {
        // 根据类型显示对应的账号
        if (data.type === '收入') {
          return data.payerAccount;
        } else if (data.type === '支出') {
          return data.payeeAccount;
        }
        return data.payerAccount || data.payeeAccount;
      },

      // 获取类型徽章样式
      getTypeBadgeClass(type) {
        switch(type) {
          case '收入':
            return 'type-income';
          case '支出':
            return 'type-expense';
          default:
            return 'type-default';
        }
      },
      needsRepair(data) {
        // 根据交易类型检查是否需要修复（只检查字段为空的情况）
        if (data.type === '支出') {
          // 支出类型：检查收款人是否为空
          return !data.payeeName;
        } else if (data.type === '收入') {
          // 收入类型：检查付款人是否为空
          return !data.payerName;
        }
        return false;
      },
      repairSingle(data) {
        this.$Confirm(`确认修复单据"${data.receiptsNo}"的数据？`).then(() => {
          this.loading = true;
          this.$api.bankReceipts.repairSingleReceipt(data.id).then(({data: result}) => {
            if (result.success) {
              this.$Message.success('修复成功');
              // 刷新列表
              this.loadList();
            } else {
              this.$Message.error(result.msg || result.message || '修复失败');
            }
          }).catch((error) => {
            console.error('修复失败:', error);
            this.$Message.error('修复失败: ' + (error.response && error.response.data && error.response.data.msg ? error.response.data.msg : error.message));
          }).finally(() => {
            this.loading = false;
          });
        });
      },
      batchRepair() {
        console.log('batchRepair方法被调用');
        // 获取当前页面需要修复的记录
        const needRepairRecords = this.datas.filter(data => this.needsRepair(data));
        console.log('需要修复的记录:', needRepairRecords);

        if (needRepairRecords.length === 0) {
          this.$Message.warning('当前页面没有需要修复的记录');
          return;
        }

        // 提取记录ID
        const receiptIds = needRepairRecords.map(record => record.id);
        console.log('提取的记录ID:', receiptIds);

        this.$Confirm(`确认批量修复当前页面的 ${needRepairRecords.length} 条"未知收款人/付款人"记录？\n\n修复后将从OCR数据中自动提取收款人/付款人信息。`).then(() => {
          console.log('用户确认批量修复');
          this.repairLoading = true;
          console.log('开始调用API，记录ID:', receiptIds);
          this.$api.bankReceipts.repairBatchReceipts(receiptIds).then(({data: result}) => {
            console.log('批量修复API响应:', result);
            if (result.success) {
              const repairedCount = result.data.repairedCount || 0;
              const totalRequested = result.data.totalRequested || receiptIds.length;
              if (repairedCount > 0) {
                this.$Message.success(`✅ 批量修复完成！成功修复 ${repairedCount} 条记录（共 ${totalRequested} 条）`);
              } else {
                this.$Message.success(`✅ 批量修复完成！当前 ${totalRequested} 条记录中没有可修复的数据`);
              }
              // 刷新列表
              this.loadList();
            } else {
              console.log('批量修复失败，响应数据:', result);
              this.$Message.error(result.msg || result.message || '批量修复失败');
            }
          }).catch((error) => {
            console.error('批量修复请求异常:', error);
            this.$Message.error('批量修复失败: ' + (error.response && error.response.data && error.response.data.msg ? error.response.data.msg : error.message));
          }).finally(() => {
            console.log('批量修复完成，设置loading为false');
            this.repairLoading = false;
          });
        }).catch(() => {
          console.log('用户取消了批量修复');
        });
      }
    },
    mounted() {
      // 初始化日期为当前账套日期
      this.accountDate = this.currentAccountSets.currentAccountDate;
      this.loadList();
    }
  };
</script>

<style lang="less" scoped>
  .modern-table {
    background: #fff;
    border-radius: 8px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
    overflow: hidden;
    margin-bottom: 20px;
  }

  .table-header {
    display: flex;
    background: linear-gradient(135deg, #2d3748 0%, #4a5568 100%);
    color: white;
    font-weight: 600;
    font-size: 14px;
    padding: 0;
  }

  .header-cell {
    padding: 16px 12px;
    display: flex;
    align-items: center;
    border-right: 1px solid rgba(255, 255, 255, 0.1);

    &:last-child {
      border-right: none;
    }
  }

  .table-row {
    display: flex;
    border-bottom: 1px solid #f0f0f0;
    transition: all 0.2s ease;

    &:hover {
      background-color: #f8f9ff;
      transform: translateY(-1px);
      box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
    }

    &:last-child {
      border-bottom: none;
    }
  }

  .row-cell {
    padding: 16px 12px;
    display: flex;
    align-items: center;
    border-right: 1px solid #f0f0f0;

    &:last-child {
      border-right: none;
    }
  }

  .cell-content {
    width: 100%;
    min-height: 20px;
  }

  .primary-text {
    font-size: 14px;
    color: #333;
    font-weight: 500;
    line-height: 1.4;
    word-break: break-all;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
  }

  .secondary-text {
    font-size: 12px;
    color: #666;
    margin-top: 4px;
    line-height: 1.3;
  }

  .amount-text {
    font-size: 16px;
    font-weight: 600;
    color: #1890ff;
    font-family: 'Courier New', monospace;
  }

  // 列宽定义
  .checkbox-cell {
    flex: 0 0 50px;
    justify-content: center;
  }

  .receipt-no-cell {
    flex: 0 0 140px;
  }

  .date-cell {
    flex: 0 0 120px;
  }

  .type-cell {
    flex: 0 0 100px;
  }

  .amount-cell {
    flex: 0 0 140px;
  }

  .party-cell {
    flex: 1 1 180px;
    min-width: 140px;
  }

  .summary-cell {
    flex: 2 1 200px;
    min-width: 150px;
  }

  .actions-cell {
    flex: 0 0 180px;
  }

  // 类型徽章样式
  .type-badge {
    display: inline-block;
    padding: 4px 8px;
    border-radius: 12px;
    font-size: 12px;
    font-weight: 500;
    text-align: center;
    white-space: nowrap;
  }

  .type-income {
    background: linear-gradient(135deg, #00b894, #00a085);
    color: white;
  }

  .type-expense {
    background: linear-gradient(135deg, #fd79a8, #e84393);
    color: white;
  }

  .type-default {
    background: linear-gradient(135deg, #e0e0e0, #bdbdbd);
    color: #333;
  }

  // 操作按钮样式
  .action-buttons {
    display: flex;
    gap: 6px;
    flex-wrap: wrap;
  }

  .action-btn {
    display: inline-flex;
    align-items: center;
    gap: 4px;
    padding: 6px 10px;
    border-radius: 6px;
    font-size: 12px;
    font-weight: 500;
    text-decoration: none;
    border: none;
    cursor: pointer;
    transition: all 0.2s ease;
    white-space: nowrap;

    &:hover {
      transform: translateY(-1px);
      box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
    }
  }

  .view-btn {
    background: linear-gradient(135deg, #74b9ff, #0984e3);
    color: white;

    &:hover {
      background: linear-gradient(135deg, #0984e3, #74b9ff);
    }
  }

  .edit-btn {
    background: linear-gradient(135deg, #00b894, #00a085);
    color: white;

    &:hover {
      background: linear-gradient(135deg, #00a085, #00b894);
    }
  }

  .repair-btn {
    background: linear-gradient(135deg, #fdcb6e, #e17055);
    color: white;

    &:hover {
      background: linear-gradient(135deg, #e17055, #fdcb6e);
    }
  }

  .delete-btn {
    background: linear-gradient(135deg, #fd79a8, #e84393);
    color: white;

    &:hover {
      background: linear-gradient(135deg, #e84393, #fd79a8);
    }
  }

  // 空状态样式
  .empty-state {
    text-align: center;
    padding: 60px 20px;
    background: #fff;
    border-radius: 8px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  }

  .empty-icon {
    font-size: 48px;
    margin-bottom: 16px;
    opacity: 0.6;
  }

  .empty-text {
    font-size: 18px;
    color: #666;
    margin-bottom: 8px;
    font-weight: 500;
  }

  .empty-hint {
    font-size: 14px;
    color: #999;
  }

  // 响应式设计
  @media (max-width: 1200px) {
    .party-cell {
      flex: 1 1 140px;
      min-width: 120px;
    }

    .summary-cell {
      flex: 1 1 150px;
      min-width: 120px;
    }

    .actions-cell {
      flex: 0 0 160px;
    }
  }

  @media (max-width: 768px) {
    .table-header,
    .table-row {
      flex-direction: column;
    }

    .header-cell,
    .row-cell {
      border-right: none;
      border-bottom: 1px solid #f0f0f0;
      padding: 12px 16px;
    }

    .row-cell {
      display: flex;
      justify-content: space-between;
      align-items: center;

      &::before {
        content: attr(data-label);
        font-weight: 600;
        color: #666;
        flex: 0 0 80px;
      }
    }
  }
</style>
